import { Injectable, Injector } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { AccountResource } from '../models/resource/account.resource';
import { Account } from '../models/ui/account.model';
import { AccountResourceToAccountMapper } from '../models/mappers/account-resource-to-account.mapper';
import { AccountToAccountResourceMapper } from '../models/mappers/account-to-account-resource.mapper';
import { FileUtility } from '../utilities/file.utility';

@Injectable({ providedIn: 'root' })
export class AccountSdk extends SdkBase {

	constructor(injector: Injector, private fileUtility: FileUtility) {
		super(injector);
	}

	public getAccounts(searchTerm?: string): Observable<Account[]> {
		let query = '';
		if(searchTerm && searchTerm?.length > 0)
			query = `?searchTerm=${searchTerm}`
		return this.makeHttpRequest<AccountResource[]>('get', `api2/accounts${query}`).pipe(
			map((response) => {
				const fromResourceMapper = new AccountResourceToAccountMapper();
				return fromResourceMapper.mapCollection(response);
			})
		);
	}

	public getAccountsManaged(searchTerm?: string): Observable<Account[]> {
		let query = '';
		if (searchTerm && searchTerm?.length > 0)
			query = `?searchTerm=${searchTerm}`
		return this.makeHttpRequest<AccountResource[]>('get', `api2/accounts/managed${query}`).pipe(
			map((response) => {
				const fromResourceMapper = new AccountResourceToAccountMapper();
				return fromResourceMapper.mapCollection(response);
			})
		);
	}

	public getAccount(accountId: string): Observable<Account> {
		return this.makeHttpRequest<AccountResource>('get', `api2/accounts/${accountId}`).pipe(
			map((response) => {
				const fromResourceMapper = new AccountResourceToAccountMapper();
				return fromResourceMapper.map(response);
			})
		);
	}

	public postAccount(account: Account): Observable<string> {
		const toResourceMapper = new AccountToAccountResourceMapper();
		const body = toResourceMapper.map(account);
		return this.makeHttpRequest<string>('post', 'api2/accounts', body);
	}

	public patchAccount(accountId: string, deltaAccount: Partial<AccountResource>): Observable<void> {
		const body = [];
		for (const key in deltaAccount) {
			body.push({
				op: "replace",
				path: `/${key}`,
				value: deltaAccount[key]
			})
		}
		return this.makeHttpRequest<void>('patch', `api2/accounts/${accountId}`, body);
	}

	public deleteAccount(accountId: string): Observable<void> {
		return this.makeHttpRequest<void>('delete', `api2/accounts/${accountId}`);
	}
}
